import React, { useEffect } from 'react';
import './index.css';
import Info from './Info.png';

const App = () => {
  useEffect(() => {
    const now = new Date();
    const scheduledTime = new Date('2025-04-29T12:30:00');

    // 현재 시간이 4월 29일 12시 30분 이후인지 확인
    const isAfterScheduledTime = now.getTime() >= scheduledTime.getTime();
    console.log(isAfterScheduledTime);

    // 현재 URL이 /api로 시작하는지 확인
    const isApiRequest = window.location.pathname.startsWith('/api');

    // 시간이 지났고, API 요청이 아닌 경우만 리다이렉트
    if (isAfterScheduledTime && !isApiRequest) {
      const targetDomain = 'https://parents.odiya.life';
      window.location.href = `${targetDomain}${window.location.pathname}${window.location.search}`;
    }
  }, []);

  return (
    <div
      style={{
        backgroundColor: '#fff',
        maxWidth: '550px',
        marginInline: 'auto',
        height: '100dvh',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          maxWidth: '550px',
          width: '100%',
          height: '100%',
          backgroundColor: '#72C4C6',
          margin: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <img src={Info} width={'300px'} height={'595px'} />
        <h3>New server</h3>
      </div>
    </div>
  );
};

export default App;
